import api from '@/store/api'
import * as OpenCC from 'opencc-js'
var All = {
  methods: {
    getTTSUrl (gender = 'female', text) {
      const isJpChat = this.$route.name === 'ChatAIJp'
      const lang = isJpChat
        ? 'ja-JP'
        : this.$store.state.selectedAccent

      const path = `/ai/generate/tts/?lang=${lang}`
      const options = { headers: { showLoading: false } }

      return api.post(
        path,
        {
          text,
          gender,
          kid: false
        },
        options
      )
      .then(res => res?.data?.url || '')
      .catch(err => {
        console.error('[getTTSUrl error]', err)
        return ''
      })
    },

    get_Translate_Dialog (theme, context, result) {
      // 會話翻譯

      let path = `/ai/generate/translate/dialog`
      if (this.$route.name === 'ChatAIJp') {
        path = `/ai/generate/d4e0a2ad-0a5a-49dc-aaef-11f370b31462`
      }
      const converter = OpenCC.Converter({ from: 'cn', to: 'tw' })
      const options = { headers: {'showLoading': false }}
      return api.post(path, {
        content: result,
        theme: theme,
        context: context
      }, options)
      .then((res) => {
        return converter(res.data.result)
      })
      .catch(() => {
      })
    },
    playAudioStandard (dynamicId) {
      let self = this

      if (self.$refs[`playBtn${dynamicId}`]) {
        let audioPlayer = self.$refs[`playBtn${dynamicId}`]

        audioPlayer.onplaying = () => {
          self.isPlaying = true
        }
        audioPlayer.onpause = () => {
          self.isPlaying = false
        }
        // 播放切換
        if (self.isPlaying) {
          audioPlayer.pause()
          audioPlayer.currentTime = 0
          self.isPlaying = false
        } else {
          audioPlayer.play()
          self.isPlaying = true
        }
      }
    },
    copy_text_selection (text) {
      navigator.clipboard.writeText(text)
    }
  }
}

export default All
